module.exports = __webpack_public_path__ + "img/curved-arrow.7a64e34f.svg";